import { render, staticRenderFns } from "./UserBackSetup.vue?vue&type=template&id=b7da7442&scoped=true&lang=pug&"
import script from "./UserBackSetup.vue?vue&type=script&lang=js&"
export * from "./UserBackSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7da7442",
  null
  
)

export default component.exports